import { createRouter, createWebHistory } from "vue-router";

import {
  checkAuthentication,
  useAuthenticate,
  getUserData,
} from "@/modules/auth/composables/useAuthenticate";

import {
  current_user,
  hasRoles,
} from "@/shared/composables/useRolePermissions";

import { hasPermission } from "@/shared/composables/useRolePermissions";

import authRoutes from "./auth.routes";
import auditsRoutes from "./audits.routes";
import profileRoutes from "./profile.routes";
import clientsRoutes from "./clients.routes";
import usersRoutes from "./users.routes";
import sellersRoutes from "./sellers.routes";
import suppliersRoutes from "./suppliers.routes";
import productsRoutes from "./products.routes";
import ordersRoutes from "./orders.routes";
import visitsRoutes from "./visits.routes";
import offersRoutes from "./offers.routes";
import priceQuotesRoutes from "./price-quotes.routes";
import productStorageRoutes from "./product-storages.routes";
import erpCodesRoutes from "./erp-codes.routes";
import publicRoutes from "./public.routes";
import mailMantainerRoutes from "./mail-maintainer.routes";
import ordersStatusRoutes from "./orders-status.routes";
import heatMapRoutes from "./heat-map.routes";

export const routes = [
  {
    path: "/auth",
    name: "auth",
    meta: { requiresAuth: false },
    component: () => import("@/modules/auth/layouts/AuthLayout.vue"),
    redirect: { name: "auth-login" },
    children: [...authRoutes],
  },

  {
    path: "/",
    name: "private",
    meta: { requiresAuth: true },
    component: () => import("@/shared/layouts/AppPrivateMainLayout.vue"),
    redirect: (to) => {
      if (hasPermission("dashboard.view")) {
        return { name: "dashboard" };
      } else {
        return { name: "profile" };
      }
    },
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        meta: {
          requiresAuth: true,
          roles: [
            "superadmin",
            "admin",
            "gerente",
            "supervisor_granos",
            "supervisor_abarrotes",
            "vendedor",
          ],
        },
        component: () => import("@/modules/dashboard/views/DashboardView.vue"),
      },
      ...profileRoutes,
      ...clientsRoutes,
      ...usersRoutes,
      ...sellersRoutes,
      ...suppliersRoutes,
      ...productsRoutes,
      ...ordersRoutes,
      ...visitsRoutes,
      ...priceQuotesRoutes,
      ...offersRoutes,
      ...productStorageRoutes,
      ...erpCodesRoutes,
      ...mailMantainerRoutes,
      ...ordersStatusRoutes,
      ...auditsRoutes,
      ...heatMapRoutes,
    ],
  },

  {
    path: "/public",
    name: "public",
    meta: { requiresAuth: false },
    component: () => import("@/shared/layouts/AppPublicMainLayout.vue"),
    children: [...publicRoutes],
  },

  {
    path: "/404",
    name: "error-404",
    meta: { requiresAuth: false },

    // component: () => import("@/shared/pages/AppError404View.vue"),
  },
  {
    path: "/500",
    name: "error-500",
    meta: { requiresAuth: false },
    // component: () => import("@/shared/pages/AppError500View.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: (to) =>
      to.meta.requiresAuth ? { name: "private" } : { name: "auth-login" },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const { isLogged } = await checkAuthentication();

  if (to.meta.requiresAuth && !isLogged) {
    sessionStorage.setItem("lastPath", to.fullPath);
    console.log("not auth!");
    return next({ name: "auth-login" });
  }

  if (!to.meta.requiresAuth && isLogged) {
    const lastPath = sessionStorage.getItem("lastPath");
    sessionStorage.removeItem("lastPath");
    return next(lastPath || { name: "private" });
  }

  if (
    to.meta.roles &&
    !to.meta.roles.some((routeRoles) =>
      current_user().roles.some((userRole) => routeRoles == userRole.name),
    )
  ) {
    return next({ name: "error-404" });
  }

  next();
});

export default router;
